import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { t } from '../../helpers/translate.js';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import '../../mixins/media.js';
import '../../mixins/keyboardFocus.js';
import '../../mixins/markStyle.js';
import '../../mixins/scrollbarStyle.js';
import { spacing } from '../../mixins/spacing.js';
import '../../mixins/textStyle.js';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup.js';
import { Flex } from '../Flex/Flex.js';
import { useSteppedForm } from './SteppedFormProvider.js';

const StyledFooter = styled(Flex).withConfig({
  componentId: "sc-7kfbmn-0"
})(["width:100%;margin-left:auto;"]);
const StyledButtonGroup = styled(ButtonGroup).withConfig({
  componentId: "sc-7kfbmn-1"
})(["margin-left:", ";"], spacing(4));
const SteppedFormFooter = /*#__PURE__*/withTitan(({
  children,
  testId = 'steppedFormFooter',
  buttonCancel,
  buttonPrevious,
  buttonNext,
  hasCancel,
  hasPrevious
}) => {
  const {
    formId,
    previousStep,
    isFirstStep
  } = useSteppedForm();
  return jsxs(StyledFooter, {
    alignItems: "center",
    justifyContent: "flex-end",
    testId: testId,
    children: [children, jsxs(StyledButtonGroup, {
      children: [hasCancel && jsx(Button, {
        isDisabled: buttonCancel === null || buttonCancel === void 0 ? void 0 : buttonCancel.isDisabled,
        testId: `${testId}Cancel`,
        variant: "clear",
        onClick: buttonCancel === null || buttonCancel === void 0 ? void 0 : buttonCancel.onClick,
        children: t((buttonCancel === null || buttonCancel === void 0 ? void 0 : buttonCancel.label) || 'Annuleren')
      }), hasPrevious && jsx(Button, {
        isDisabled: (buttonPrevious === null || buttonPrevious === void 0 ? void 0 : buttonPrevious.isDisabled) !== undefined ? buttonPrevious.isDisabled : isFirstStep,
        testId: `${testId}Previous`,
        onClick: e => {
          previousStep();
          if (buttonPrevious === null || buttonPrevious === void 0 ? void 0 : buttonPrevious.onClick) {
            buttonPrevious.onClick(e);
          }
        },
        children: t((buttonPrevious === null || buttonPrevious === void 0 ? void 0 : buttonPrevious.label) || 'Vorige')
      }), jsx(Button, {
        form: formId,
        isDisabled: buttonNext === null || buttonNext === void 0 ? void 0 : buttonNext.isDisabled,
        testId: `${testId}Next`,
        type: "submit",
        onClick: buttonNext === null || buttonNext === void 0 ? void 0 : buttonNext.onClick,
        children: t((buttonNext === null || buttonNext === void 0 ? void 0 : buttonNext.label) || 'Volgende')
      })]
    })]
  });
}, {
  name: 'SteppedFormFooter'
});

export { SteppedFormFooter };
//# sourceMappingURL=SteppedFormFooter.js.map
